exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".login-form {\n  max-width: 300px;\n  float: none;\n  height: auto;\n  margin: 0 auto !important;\n  padding: 10px !important;\n}\n\n.login-form-forgot {\n  float: right;\n}\n\n.login-form-button {\n  width: 100%;\n}\n\n\n.Login .ant-layout-content {\n  display: -ms-flexbox;\n  display: flex;\n  min-height: 100vh;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  overflow: auto;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"importLoaders":1}!../node_modules/postcss-loader/lib?{"ident":"postcss"}!./src/scenes/Login/Login.css
// module id = ../node_modules/css-loader/index.js?{"importLoaders":1}!../node_modules/postcss-loader/lib/index.js?{"ident":"postcss"}!./src/scenes/Login/Login.css
// module chunks = 0